import {
  GET_DIMENSIONS_DATA_WATCHER,
  GET_DIMENSIONS_DATA_SUCCESS,
  GET_DIMENSIONS_DATA_FAILED,
} from "./constants"

export function getDimensionsDataWatcher(payload) {
  return {
    type: GET_DIMENSIONS_DATA_WATCHER,
    payload,
  }
}

export function getDimensionsDataSuccess(payload) {
  return {
    type: GET_DIMENSIONS_DATA_SUCCESS,
    payload,
  }
}

export function getDimensionsDataFailed() {
  return { type: GET_DIMENSIONS_DATA_FAILED }
}
